import React from 'react'
import Scanner from '../Components/Scanner/Scanner';
import "./scan.scss";
const Scan = () => {
    return (
        <div className="wcs_scan">
            <div className="wcs_scancontainer">
                <Scanner />
            </div>
        </div>
    )
}

export default Scan
